import React, { useEffect, useCallback, useState} from 'react';
import {freezePatterns} from 'components/v2/trackRightClickActions.js';
import {
    setShowFreezeModal,
    } from 'actions/index.js';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';
import { Button } from 'reactstrap';
import './freeze-modal.scss';

const FreezeModal = ({sequencerEngine, setShowFreezeModal}) => { 
    let [freezeOption, setFreezeOption] = useState("pad");

    const startFreezing = useCallback(() => {
        if (freezeOption === "pad") {
            let pad = sequencerEngine.state.spatial.showPadSequencer;
            pad.zObject.executeAction("Freeze Pads");
        } else {
            freezePatterns(sequencerEngine.getSelectedTrack());
        }
        setShowFreezeModal(false);
    }, [freezeOption, sequencerEngine]);

    return (
        <Modal dialogClassName="freeze-modal" show={true} onHide={() => setShowFreezeModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>
              Freeze
              <img src="/freeze-icon.svg"/>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="freeze-options">
              <div
                onClick={x => setFreezeOption("pad")}
                className={freezeOption === "pad" ? "selected freeze-option": "freeze-option"}>
                Pad <img src="/zpad-light.svg"/>
              </div>
              <div
                onClick={x => setFreezeOption("track")}
                className={freezeOption === "track" ? "selected freeze-option": "freeze-option"}>
                Track
              </div>
              <div className="freeze-description">
                {freezeOption === "pad" ? 
                 "Bounce audio from all tracks into a single frozen stem." : "Bounce audio from the selected track into a frozen stem."}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={startFreezing}
              className="pushable" variant="secondary">
              Start Freezing
            </Button>
          </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setShowFreezeModal: x => dispatch(setShowFreezeModal(x))
  };

};

export default connect(mapStateToProps, mapDispatchToProps)(FreezeModal);
